import React from 'react';
import { withStyles, Typography } from '@material-ui/core';
import ContentHeader from '../components/ContentHeader';
import ViewTicketButtons from '../components/ViewTicketButtons';

const styles = theme => ({
    root: {
        textAlign: 'center',
        border: '0',
        maxWidth: '800px',
        margin: '40px auto',
        position: 'relative',
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    heading: {
        marginBottom: '10px'
    },
    subheading: {
        marginTop: '20px'
    },
    paragraph: {
        fontSize: '16px',
        marginBottom: '10px',
        fontWeight: '100'
    },
    inner: {
        padding: '20px 10px'
    }
});

const RenewalConfirmed = ({ classes, match }) => {
    const {
        params: { ticketId }
    } = match;

    return (
        <div className={classes.root}>
            <ContentHeader
                text="Renewal Confirmed"
                id="order-confirmed-heading"
            />
            <div className={classes.inner}>
                <Typography className={classes.paragraph} variant="body2">
                    Congratulations, your order was successful and your new{' '}
                    ticket is ready to use.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    Tickets will be scanned onboard and will need to be
                    presented by the passenger.
                </Typography>
                <Typography
                    style={{ maxWidth: 600, margin: '0 auto' }}
                    className={classes.paragraph}
                    variant="body2"
                >
                    <span style={{ color: 'red' }}>IMPORTANT:</span> Please note
                    your previous ticket will stop working when it expires and
                    your new ticket can only be used from the start date
                    displayed on the ticket.
                </Typography>

                <ViewTicketButtons ticketId={ticketId} />
            </div>
        </div>
    );
};

export default withStyles(styles)(RenewalConfirmed);
